import { render, staticRenderFns } from "./LotParkingCreate.vue?vue&type=template&id=b223202e&"
import script from "./LotParkingCreate.vue?vue&type=script&lang=js&"
export * from "./LotParkingCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports